import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
var _class, _SwipeEvents_brand;
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import { isTesting } from "discourse-common/config/environment";
import { bind } from "discourse-common/utils/decorators";

// common max animation time in ms for swipe events for swipe end
// prefers reduced motion and tests return 0
export function getMaxAnimationTimeMs() {
  let durationMs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : MAX_ANIMATION_TIME;
  if (isTesting() || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    return 0;
  }
  return Math.min(durationMs, MAX_ANIMATION_TIME);
}

//functions to calculate if a swipe should close
//based on origin of right, left, top, bottom
// menu should close after a swipe either:
// if a user moved the panel closed past a threshold and away and is NOT swiping back open
// if a user swiped to close fast enough regardless of distance
export function shouldCloseMenu(e, origin) {
  if (origin === "right") {
    return e.deltaX > SWIPE_DISTANCE_THRESHOLD && e.velocityX > -SWIPE_VELOCITY_THRESHOLD || e.velocityX > 0;
  } else if (origin === "left") {
    return e.deltaX < -SWIPE_DISTANCE_THRESHOLD && e.velocityX < SWIPE_VELOCITY_THRESHOLD || e.velocityX < 0;
  } else if (origin === "bottom") {
    return e.deltaY > SWIPE_DISTANCE_THRESHOLD && e.velocityY > -SWIPE_VELOCITY_THRESHOLD || e.velocityY > 0;
  } else if (origin === "top") {
    return e.deltaY < -SWIPE_DISTANCE_THRESHOLD && e.velocityY < SWIPE_VELOCITY_THRESHOLD || e.velocityY < 0;
  }
  return false;
}

/**
   Swipe events is a class that allows components to detect and respond to swipe gestures
   It sets up custom events for swipestart, swipeend, and swipe for beginning swipe, end swipe, and during swipe. Event returns detail.state with swipe state, and the original event.

   Calling preventDefault() on the swipestart event stops swipe and swipeend events for the current gesture. it is re-enabled on future swipe events.
**/
export const SWIPE_DISTANCE_THRESHOLD = 50;
export const SWIPE_VELOCITY_THRESHOLD = 0.12;
export const MINIMUM_SWIPE_DISTANCE = 5;
export const MAX_ANIMATION_TIME = 200;
let SwipeEvents = (_class = (_SwipeEvents_brand = /*#__PURE__*/new WeakSet(), class SwipeEvents {
  constructor(element) {
    _classPrivateMethodInitSpec(this, _SwipeEvents_brand);
    //velocity is pixels per ms
    _defineProperty(this, "swipeState", null);
    _defineProperty(this, "animationPending", false);
    this.element = element;
  }
  touchStart(e) {
    // multitouch cancels current swipe event
    if (e.touches.length > 1) {
      if (this.cancelled) {
        return;
      }
      this.cancelled = true;
      const event = new CustomEvent("swipecancel", {
        detail: {
          originalEvent: e
        }
      });
      this.element.dispatchEvent(event);
      return;
    }
    this.swipeState = _assertClassBrand(_SwipeEvents_brand, this, _swipeStart).call(this, e.touches[0]);
  }
  touchMove(e) {
    const touchEvent = e.touches[0];
    touchEvent.type = "pointermove";
    _assertClassBrand(_SwipeEvents_brand, this, _swipeMove).call(this, touchEvent, e);
  }
  touchEnd(e) {
    _assertClassBrand(_SwipeEvents_brand, this, _swipeMove).call(this, {
      type: "pointerup"
    }, e);
    // only reset when no touches remain
    if (e.touches.length === 0) {
      this.cancelled = false;
    }
  }
  touchCancel(e) {
    _assertClassBrand(_SwipeEvents_brand, this, _swipeMove).call(this, {
      type: "pointercancel"
    }, e);
    if (e.touches.length === 0) {
      this.cancelled = false;
    }
  }
  addTouchListeners() {
    const opts = {
      passive: false
    };
    this.element.addEventListener("touchstart", this.touchStart, opts);
    this.element.addEventListener("touchmove", this.touchMove, opts);
    this.element.addEventListener("touchend", this.touchEnd, opts);
    this.element.addEventListener("touchcancel", this.touchCancel, opts);
  }

  // Remove touch listeners to be called by client on destory
  removeTouchListeners() {
    this.element.removeEventListener("touchstart", this.touchStart);
    this.element.removeEventListener("touchmove", this.touchMove);
    this.element.removeEventListener("touchend", this.touchEnd);
    this.element.removeEventListener("touchcancel", this.touchCancel);
  }
}), (_applyDecoratedDescriptor(_class.prototype, "touchStart", [bind], Object.getOwnPropertyDescriptor(_class.prototype, "touchStart"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "touchMove", [bind], Object.getOwnPropertyDescriptor(_class.prototype, "touchMove"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "touchEnd", [bind], Object.getOwnPropertyDescriptor(_class.prototype, "touchEnd"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "touchCancel", [bind], Object.getOwnPropertyDescriptor(_class.prototype, "touchCancel"), _class.prototype)), _class);
function _calculateDirection(oldState, deltaX, deltaY) {
  if (oldState.start || !oldState.direction) {
    if (Math.abs(deltaX) > Math.abs(deltaY)) {
      return deltaX > 0 ? "right" : "left";
    } else {
      return deltaY > 0 ? "down" : "up";
    }
  }
  return oldState.direction;
}
function _calculateNewSwipeState(oldState, e) {
  if (e.type === "pointerup" || e.type === "pointercancel") {
    return oldState;
  }
  const newTimestamp = Date.now();
  const timeDiffSeconds = newTimestamp - oldState.timestamp;
  if (timeDiffSeconds === 0) {
    return oldState;
  }
  //calculate delta x, y from START location
  const deltaX = e.clientX - oldState.startLocation.x;
  const deltaY = e.clientY - oldState.startLocation.y;

  //calculate velocity from previous event center location
  const eventDeltaX = e.clientX - oldState.center.x;
  const eventDeltaY = e.clientY - oldState.center.y;
  const velocityX = eventDeltaX / timeDiffSeconds;
  const velocityY = eventDeltaY / timeDiffSeconds;
  const direction = _assertClassBrand(_SwipeEvents_brand, this, _calculateDirection).call(this, oldState, deltaX, deltaY);
  return {
    startLocation: oldState.startLocation,
    center: {
      x: e.clientX,
      y: e.clientY
    },
    velocityX,
    velocityY,
    deltaX,
    deltaY,
    start: false,
    timestamp: newTimestamp,
    direction,
    element: this.element,
    goingUp: () => direction === "up",
    goingDown: () => direction === "down"
  };
}
function _swipeStart(e) {
  return {
    center: {
      x: e.clientX,
      y: e.clientY
    },
    startLocation: {
      x: e.clientX,
      y: e.clientY
    },
    velocityX: 0,
    velocityY: 0,
    deltaX: 0,
    deltaY: 0,
    start: true,
    timestamp: Date.now(),
    direction: null,
    element: this.element,
    goingUp: () => false,
    goingDown: () => false
  };
}
function _swipeMove(e, originalEvent) {
  if (this.cancelled) {
    return;
  }
  if (!this.swipeState) {
    this.swipeState = _assertClassBrand(_SwipeEvents_brand, this, _swipeStart).call(this, e);
    return;
  }
  originalEvent.stopPropagation();
  const previousState = this.swipeState;
  const newState = _assertClassBrand(_SwipeEvents_brand, this, _calculateNewSwipeState).call(this, previousState, e);
  if (previousState.start && Math.abs(newState.deltaX) < MINIMUM_SWIPE_DISTANCE && Math.abs(newState.deltaY) < MINIMUM_SWIPE_DISTANCE) {
    return;
  }
  this.swipeState = newState;
  newState.originalEvent = originalEvent;
  if (previousState.start) {
    const event = new CustomEvent("swipestart", {
      cancelable: true,
      detail: newState
    });
    this.cancelled = !this.element.dispatchEvent(event);
    if (this.cancelled) {
      return;
    }
    this.swiping = true;
  } else if ((e.type === "pointerup" || e.type === "pointercancel") && this.swiping) {
    this.swiping = false;
    const event = new CustomEvent("swipeend", {
      detail: newState
    });
    this.element.dispatchEvent(event);
  } else if (e.type === "pointermove") {
    if (this.animationPending) {
      return;
    }
    this.animationPending = true;
    window.requestAnimationFrame(() => {
      if (!this.animationPending || !this.swiping || this.cancelled) {
        this.animationPending = false;
        return;
      }
      const event = new CustomEvent("swipe", {
        detail: newState
      });
      this.element.dispatchEvent(event);
      this.animationPending = false;
    });
  }
}
export { SwipeEvents as default };